module.exports = __webpack_public_path__ + "img/logo-inverse.75bf8691.png";